import { BahasaResponse } from "../../../../models/Bahasa";
import { KegiatanSosialResponse } from "../../../../models/KegiatanSosial";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function kegiatanSosial(
  KEGIATAN_SOSIAL_ID: number
): Promise<KegiatanSosialResponse> {
  const res = await ApiClient.get(
    `/KegiatanSosial?KEGIATAN_SOSIAL_ID=${KEGIATAN_SOSIAL_ID}`
  );
  return res.data[0];
}

export const useFetchKegiatanSosial = mutationWrapper(kegiatanSosial);
